module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('range', {
    attrs: {
      "label": _vm.$t('edit.sidebar.height'),
      "min": "50",
      "max": "150",
      "step": "1",
      "value": _vm.value(),
      "change": _vm.onChange,
      "move": _vm.onMove
    }
  })
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-7d8124ed!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/triggerbutton/Height.vue
 ** module id = 875
 ** module chunks = 1
 **/